<template>
	<div class="page">
		<div class="hero">
			<div class="hero-bg"></div>
			<i class="el-icon-guide"></i>
			<h1>全球获客系统</h1>
			<p class="subtitle">全球企业情报库 · 采购商资源 · 批量联系方式查询 · 社媒客群定向</p>
			<div class="badges">
				<span class="badge">企业情报</span>
				<span class="badge">广交会数据</span>
				<span class="badge">批量查询</span>
				<span class="badge">社媒客群</span>
			</div>
			<ul class="shapes">
				<li></li><li></li><li></li><li></li><li></li>
				<li></li><li></li><li></li><li></li><li></li>
				<li></li><li></li>
			</ul>
			<ul class="ribbons"><li></li><li></li><li></li></ul>
			<div class="actions">
				<el-button class="custom-button" @click="open('https://wm.shuhailinghang.cn/')">前往外贸系统</el-button>
			</div>
		</div>
		<div class="section">
			<h2>系统介绍</h2>
			<div class="cards">
				<div class="card intro-card">
					<p>数海领航全球获客系统的全球企业信息查询功能，是外贸人“情报库”，整合多行业海量数据，轻点即可获取目标企业架构、经营、产品、市场等详情；数据定期更新，助你足不出户掌全球市场动态、快人一步定策略。整合广交会资源，清晰呈现参展采购商名称、主营产品与采购需求，助你精准对接潜客、高效洽谈合作。平台支持批量查询手机号、企业邮箱等联系方式，并可算法筛选领英、Facebook、Twitter 等定向客群并分析需求，助力拓展人脉与合作机会。</p>
				</div>
			</div>
		</div>
		<div class="bottom-section">
			<div class="card feature-grid">
				<div class="feature"><i class="el-icon-office-building"></i><span>企业画像</span></div>
				<div class="feature"><i class="el-icon-s-data"></i><span>展会数据</span></div>
				<div class="feature"><i class="el-icon-mobile-phone"></i><span>联系方式</span></div>
				<div class="feature"><i class="el-icon-user-solid"></i><span>社媒定向</span></div>
			</div>
		</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'GlobalAcquisition',
	methods: { 
		open(url){ 
			try {
				// 尝试使用 window.open
				const newWindow = window.open(url, '_blank');
				
				// 检查是否被阻止
				if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
					// 如果弹窗被阻止，尝试直接跳转
					window.location.href = url;
				}
			} catch (error) {
				console.error('跳转失败:', error);
				// 如果都失败了，尝试直接跳转
				window.location.href = url;
			}
		} 
	}
}
</script>

<style scoped>
.page { padding: 24px 24px 48px; width: 100%; max-width: none; margin: 0 auto; background: linear-gradient(180deg, #f7fffe 0%, #f2fffb 60%, #f0fffb 100%); border-radius: 12px; min-height: calc(100vh - 48px); display: flex; flex-direction: column; }
.hero { position: relative; overflow: hidden; background: linear-gradient(135deg, #e6fffb 0%, #f6ffed 100%); padding: 40px 24px; border-radius: 12px; text-align: center; }
.hero-bg { position: absolute; inset: -20%; background: radial-gradient(circle at 20% 20%, rgba(255,255,255,0.85), transparent 40%), radial-gradient(circle at 80% 30%, rgba(255,255,255,0.65), transparent 45%), radial-gradient(circle at 40% 80%, rgba(255,255,255,0.55), transparent 50%); filter: blur(8px); }
.hero i { position: relative; z-index: 1; font-size: 56px; color: #13c2c2; animation: pop 2.6s ease-in-out infinite; }
.hero h1 { position: relative; z-index: 1; margin: 28px 0 28px; font-size: 36px; letter-spacing: 0.3px; background: linear-gradient(90deg, #0f3d3a, #13c2c2, #0f3d3a) !important; -webkit-background-clip: text !important; background-clip: text !important; color: transparent !important; text-shadow: none !important; background-size: 200% 100%; animation: titleShimmer 6s linear infinite; }
.subtitle { position: relative; z-index: 1; color: #0f3d3a; margin-bottom: 32px; font-size: 18px; font-weight: 700; line-height: 2.1; padding: 8px 12px; background: rgba(255,255,255,0.68); border-radius: 8px; display: inline-block; }
.badges { position: relative; z-index: 1; display: flex; gap: 12px; justify-content: center; flex-wrap: wrap; margin: 20px 0 32px; }
.badge { background: rgba(19,194,194,0.14); color: #0f2b46; padding: 6px 12px; border-radius: 999px; font-size: 13px; font-weight: 700; text-shadow: 0 1px 1px rgba(255,255,255,0.6); }
@keyframes floaty { 0% { transform: translateY(0) rotate(0); } 50% { transform: translateY(-6px) rotate(2deg);} 100% { transform: translateY(0) rotate(0);} }
@keyframes pop { 0%,100% { transform: scale(1);} 50% { transform: scale(1.06);} }
.shapes { position: absolute; inset: 0; margin: 0; padding: 0; list-style: none; pointer-events: none; }
.shapes li { position: absolute; left: 0; top: -20%; width: 28px; height: 28px; background: rgba(19,194,194,0.28); border-radius: 6px; animation: fallDown 12s linear infinite; }
.shapes li:nth-child(1){ left: 6%; width: 36px; height: 36px; animation-duration: 14s; animation-delay: .2s; }
.shapes li:nth-child(2){ left: 22%; width: 48px; height: 48px; animation-duration: 16s; animation-delay: .6s; }
.shapes li:nth-child(3){ left: 34%; width: 30px; height: 30px; animation-duration: 12s; animation-delay: .1s; }
.shapes li:nth-child(4){ left: 56%; width: 42px; height: 42px; animation-duration: 18s; animation-delay: .4s; }
.shapes li:nth-child(5){ left: 72%; width: 28px; height: 28px; animation-duration: 13s; animation-delay: .3s; }
.shapes li:nth-child(6){ left: 86%; width: 60px; height: 60px; animation-duration: 17s; animation-delay: .5s; }
.shapes li:nth-child(7){ left: 14%; width: 26px; height: 26px; animation-duration: 11s; animation-delay: .7s; }
.shapes li:nth-child(8){ left: 44%; width: 40px; height: 40px; animation-duration: 15s; animation-delay: .9s; }
.shapes li:nth-child(9){ left: 64%; width: 34px; height: 34px; animation-duration: 13s; animation-delay: .3s; }
.shapes li:nth-child(10){ left: 80%; width: 46px; height: 46px; animation-duration: 16s; animation-delay: .8s; }
.shapes li:nth-child(11){ left: 26%; width: 24px; height: 24px; animation-duration: 12s; animation-delay: .4s; }
.shapes li:nth-child(12){ left: 46%; width: 52px; height: 52px; animation-duration: 18s; animation-delay: .6s; }
@keyframes fallDown { 0% { transform: translateY(-20vh) rotate(0deg); opacity: .9; } 100% { transform: translateY(120vh) rotate(360deg); opacity: .6; } }
.feature { transition: transform .25s ease, box-shadow .25s ease; }
.feature:hover { transform: translateY(-3px); box-shadow: 0 10px 18px rgba(19,194,194,0.12); }
.feature i { font-size: 18px; margin-right: 6px; }
.actions { position: relative; z-index: 1; margin-top: 28px; display: flex; gap: 10px; justify-content: center; flex-wrap: wrap; }
.section { margin-top: 16px; }
.section h2 { margin: 0 0 32px; }
.cards { display: grid; grid-template-columns: 1fr; gap: 24px; }
.card { background: #ffffff; border: 1px solid #e6f4f1; border-radius: 12px; }
.intro-card { padding: 24px 28px; color: #244f4c; line-height: 2.0; font-size: 16.5px; }
.intro-card p { max-width: 900px; margin: 0 auto; word-break: break-word; }
.feature-grid { padding: 16px; display: grid; grid-template-columns: repeat(4, minmax(160px, 1fr)); gap: 12px; }
.feature { background: #f3fffb; border: 1px solid #e6f4f1; padding: 12px; border-radius: 10px; display: flex; align-items: center; gap: 8px; justify-content: center; color: #2c6662; }
.bottom-section { margin-top: auto; padding-top: 32px; padding-bottom: 24px; }
.feature i { color: #13c2c2; font-size: 18px; margin-right: 6px; }
.hero { background-size: 200% 200%; animation: gradientShift 14s ease infinite; }
.hero::before { content: ""; position: absolute; inset: 0; background: radial-gradient(600px 300px at 15% 10%, rgba(255,255,255,0.35), transparent 60%), radial-gradient(500px 260px at 85% 20%, rgba(255,255,255,0.25), transparent 60%); pointer-events: none; }
@keyframes gradientShift { 0% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } 100% { background-position: 0% 50%; } }
.shapes li { filter: blur(0.2px); opacity: 0.7; }
.shapes li:nth-child(1){ width: 18px; height: 18px; animation-duration: 5s; animation-delay: .2s; }
.shapes li:nth-child(2){ width: 22px; height: 22px; animation-duration: 6.5s; animation-delay: .6s; }
.shapes li:nth-child(3){ width: 14px; height: 14px; animation-duration: 4.8s; animation-delay: .1s; }
.shapes li:nth-child(4){ width: 28px; height: 28px; animation-duration: 7s; animation-delay: .4s; }
.shapes li:nth-child(5){ width: 16px; height: 16px; animation-duration: 5.6s; animation-delay: .3s; }
/* Badge glow pulse */
.badge { box-shadow: 0 0 0 rgba(19,194,194,0.0); animation: glowPulse 3.2s ease-in-out infinite; }
@keyframes glowPulse { 0%,100% { box-shadow: 0 0 0 rgba(19,194,194,0); } 50% { box-shadow: 0 8px 18px rgba(19,194,194,0.22); } }
.actions .el-button { transition: transform .25s ease, box-shadow .25s ease; }
.actions .el-button:hover { transform: translateY(-2px) scale(1.02); box-shadow: 0 10px 22px rgba(19,194,194,0.18); }

/* Custom button styling */
.actions .custom-button {
	background: #13c2c2;
	border-color: #13c2c2;
	color: white;
}
.actions .custom-button:hover {
	background: #36cfc9;
	border-color: #36cfc9;
	box-shadow: 0 10px 22px rgba(19,194,194,0.18);
}
/* Feature cards entrance with floaty animation */
.feature { animation: cardIn .5s ease both, floaty 6.5s ease-in-out .6s infinite; }
.feature:nth-child(1){ animation-delay: .05s; }
.feature:nth-child(2){ animation-delay: .12s; }
.feature:nth-child(3){ animation-delay: .19s; }
.feature:nth-child(4){ animation-delay: .26s; }
@keyframes cardIn { from { opacity: 0; transform: translateY(8px);} to { opacity: 1; transform: translateY(0);} }
@keyframes floaty { 0% { transform: translateY(0) rotate(0); } 50% { transform: translateY(-6px) rotate(2deg);} 100% { transform: translateY(0) rotate(0);} }

/* Button breathing */
.actions .el-button { animation: breathe 3.6s ease-in-out .2s infinite; }
@keyframes breathe { 0%,100% { transform: translateY(0) scale(1); } 50% { transform: translateY(-1px) scale(1.03); } }
</style>
<style scoped>
.ribbons { position: absolute; inset: 0; margin: 0; padding: 0; list-style: none; pointer-events: none; z-index: 0; }
.ribbons li { position: absolute; left: -10%; right: -10%; height: 140px; filter: blur(18px); opacity: 0.55; background: linear-gradient(90deg, rgba(19,194,194,0.0), rgba(19,194,194,0.45), rgba(19,194,194,0.0)); animation: sweep 9s ease-in-out infinite; }
.ribbons li:nth-child(1){ top: 10%; }
.ribbons li:nth-child(2){ top: 45%; animation-delay: 1.2s; height: 160px; opacity: 0.6; }
.ribbons li:nth-child(3){ top: 78%; animation-delay: 2.4s; height: 130px; opacity: 0.5; }
@keyframes sweep { 0% { transform: translateX(-10%) rotate(0.5deg);} 50% { transform: translateX(10%) rotate(-0.5deg);} 100% { transform: translateX(-10%) rotate(0.5deg);} }
</style> 